<template>
  <div class="phone-frame">
    <div class="phone-notch"></div>
    <div class="line-header">
      <i class="ri-arrow-left-s-line"></i>
      <span class="line-header-title">LINE 預覽</span>
      <div class="line-header-actions">
        <i class="ri-phone-line"></i>
        <i class="ri-menu-line"></i>
      </div>
    </div>

    <div class="chat-area">
      <LineChatMessages
        :messages="chatMessages"
        :empty-text="emptyText"
        welcome-text=""
      />
    </div>

    <div class="line-input-bar">
      <i class="ri-add-circle-line"></i>
      <div class="input-mock">Aa</div>
      <i class="ri-mic-line"></i>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import LineChatMessages from '@/components/LineChatMessages.vue';

const props = defineProps({
  // ── 多則模式：傳入陣列 ──────────────────────────────────
  messages: { type: Array, default: null },

  // ── 單則模式（向下相容）────────────────────────────────
  messageType:    { type: String, default: '' },
  textContent:    { type: String, default: '' },
  textEmojis:     { type: Array,  default: () => [] },
  imageUrl:       { type: String, default: '' },
  previewImageUrl:{ type: String, default: '' },
  imagemapUrl:    { type: String, default: '' },
  imagemapAreas:  { type: Array,  default: () => [] },
  carouselItems:  { type: Array,  default: () => [] },
  flexContent:    { type: Object, default: null },

  emptyText: { type: String, default: '選擇範本後即時預覽' }
});

/**
 * 將 prop 統一轉為 LineChatMessages 的 messages 格式（role: 'bot'）
 * 外部若已傳入帶 role 的陣列，直接原樣傳遞（兼容 user/tip 訊息）
 */
const chatMessages = computed(() => {
  if (props.messages && props.messages.length > 0) {
    // 若訊息已有 role 欄位（富文選單模擬等），直接使用
    if (props.messages[0]?.role !== undefined) return props.messages;
    // 舊格式（messageType 物件陣列）自動加上 role: 'bot'
    return props.messages.map(m => ({ role: 'bot', ...m }));
  }
  if (!props.messageType) return [];
  return [{
    role: 'bot',
    messageType:     props.messageType,
    textContent:     props.textContent,
    textEmojis:      props.textEmojis || [],
    imageUrl:        props.imageUrl,
    previewImageUrl: props.previewImageUrl,
    imagemapUrl:     props.imagemapUrl,
    imagemapAreas:   props.imagemapAreas,
    carouselItems:   props.carouselItems,
    flexContent:     props.flexContent,
  }];
});
</script>

<style scoped>
.phone-frame {
  width: 320px;
  height: 690px;
  border: 3px solid #1f2937;
  border-radius: 36px;
  background: #E8E5DE;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  box-shadow: 0 8px 32px rgba(0,0,0,.15);
}

.phone-notch {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 120px;
  height: 20px;
  background: #1f2937;
  border-radius: 0 0 16px 16px;
  z-index: 10;
}

.line-header {
  display: flex;
  align-items: center;
  padding: 28px 14px 10px;
  background: #06C755;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  gap: 8px;
  flex-shrink: 0;
}
.line-header i { font-size: 20px; }
.line-header-title { flex: 1; }
.line-header-actions { display: flex; gap: 12px; }

.chat-area {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 12px;
  min-width: 0;
  background: #E8E5DE;
}

.line-input-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 14px;
  background: #fff;
  border-top: 1px solid #e5e7eb;
  flex-shrink: 0;
}
.line-input-bar i { font-size: 22px; color: #6b7280; }
.input-mock {
  flex: 1;
  padding: 6px 14px;
  background: #f3f4f6;
  border-radius: 18px;
  font-size: 13px;
  color: #9ca3af;
}
</style>
